// extracted by mini-css-extract-plugin
export default {"section":"index_section__5MiEM","title":"index_title__tHWab","device":"index_device__l9IPU"};